import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useAuth } from "./AuthContext";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [incomingCall, setIncomingCall] = useState(null);
  const { userId } = useAuth();

  useEffect(() => {
    //const newSocket = io("http://localhost:5002");
    //const newSocket = io("https://trippin.icu");

     const newSocket = io("https://api.trippin.icu", {
       transports: ["websocket"],
       withCredentials: true,
     });
    setSocket(newSocket);

    newSocket.on("incoming-call", (callData) => {
      console.log("[client] incoming-call", callData);
      setIncomingCall(callData); // { from: userId, signal, name, isVideo }
    });

    newSocket.on("connect_error", (err) => {
      console.error("[client] socket connect_error", err);
    });

    return () => newSocket.close();
  }, []);

  useEffect(() => {
    if (!socket) return;

    const sendRegister = () => {
      if (userId) {
        console.log("[client] emit register", { userId });
        socket.emit("register", { userId });
      }
    };

    socket.on("connect", sendRegister);

    // If already connected when userId becomes available
    if (socket.connected) sendRegister();

    return () => {
      socket.off("connect", sendRegister);
    };
  }, [socket, userId]);

  useEffect(() => {
    if (!socket) return;

    socket.onAny((event, ...args) => {
      console.log("[client] socket event:", event, args);
    });

    return () => {
      socket.offAny();
    };
  }, [socket]);

  return (
    <SocketContext.Provider value={{ socket, incomingCall, setIncomingCall }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);